import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

import BPO from "../../components/Service/BPO";
import PageHeader from "../../components/ui/PageHeader";
import AnimatePage from "../../components/ui/AnimatePage";
import AboutUs from "../../components/Service/AboutUs";
import Container from "../../components/ui/Container";



const AboutUsPage: React.FC = () => {
  return (

      <Container>
        <AboutUs/>
      </Container>


  );
};

export default AboutUsPage;

